import React from "react";


export default function MessageRed(message) {
    return (
        <div className="flex items-center justify-center text-center text-xl text-red-600 bg-red-50 h-full
            rounded-md mx-auto w-full">
            <h2 className="font-bold">{message.message}</h2>
        </div>
    )
}
